import { AuthStore } from '../../core/store/authStore';
import { AuthModal } from './AuthModal';
import { AuthService } from '../../services/AuthService';
import { RadioPlayer } from './RadioPlayer';
import { AchievementService } from '../../services/AchievementService';

export class NavBar {
  static render(activeTab: string, onNavigate: (tab: string) => void): HTMLElement {
    const user = AuthStore.getUser();
    const isAdmin = user?.role === 'admin';

    const tabs = [
      { id: 'lobby', icon: '🎮', label: 'Oyunlar' },
      { id: 'niche', icon: '🧪', label: 'Niş & Labs' },
      { id: 'leaderboard', icon: '🏆', label: 'Liderlik' },
      { id: 'profile', icon: '👤', label: 'Profil' }
    ];
    
    if (isAdmin) {
      tabs.push({ id: 'admin', icon: '🛡️', label: 'Yönetim' });
    }

    const header = document.createElement('header');
    header.style.cssText = `
      padding: 12px 28px;
      background: rgba(15, 23, 42, 0.9);
      backdrop-filter: blur(16px);
      border-bottom: 2px solid #334155;
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: sticky;
      top: 0;
      z-index: 999;
      box-shadow: 0 8px 24px rgba(0,0,0,0.4);
    `;

    header.innerHTML = `
      <!-- Logo Title & NavBar Embedded Compact Radio Player -->
      <div style="display: flex; align-items: center; gap: 10px;">
        <div style="display: flex; align-items: center; gap: 8px; cursor: pointer;" id="nav-logo">
          <span style="font-size: 2rem; filter: drop-shadow(0 0 8px #6366f1);">🕹️</span>
          <h1 style="font-size: 1.4rem; font-weight: 800; letter-spacing: -0.02em; white-space: nowrap;" class="gradient-text animated-logo">ARCADE PORTAL</h1>
        </div>
      </div>

      <!-- Hamburger Button (Mobile Only) -->
      <button id="hamburger-btn" style="display: none; font-size: 1.8rem; background: transparent; border: none; color: #f8fafc; cursor: pointer; padding: 4px;">
        &#9776;
      </button>

      <!-- Şık, Dengeli ve Belirgin Menü -->
      <nav id="nav-menu" style="display: flex; gap: 8px; align-items: center; flex-wrap: wrap; justify-content: center;">
        
        <!-- Radio Player is moved inside the nav menu so it stacks neatly on mobile -->
        <div id="nav-radio-container" style="margin-right: 12px;"></div>

        ${tabs.map(tab => `
          <button data-tab="${tab.id}" class="nav-btn ${activeTab === tab.id ? 'nav-btn--active' : ''}">
            <span class="nav-btn__icon">${tab.icon}</span>
            <span class="nav-btn__text">${tab.label}</span>
          </button>
        `).join('')}

        ${
          user
            ? `
          <div style="display: flex; align-items: center; gap: 10px; margin-left: 10px; padding-left: 14px; border-left: 2px solid #334155; flex-wrap: wrap; justify-content: center;">
            <div style="display: flex; align-items: center; gap: 6px; background: rgba(56, 189, 248, 0.1); border: 1px solid rgba(56, 189, 248, 0.3); padding: 5px 12px; border-radius: 16px;" title="Seviye: ${Math.floor(AchievementService.getUnlockedCount() / 3) + 1}">
              <span style="font-size: 0.95rem; background: linear-gradient(135deg, #22c55e, #16a34a); color: white; padding: 2px 6px; border-radius: 6px; font-weight: 800; font-size: 0.75rem;">Lvl ${Math.floor(AchievementService.getUnlockedCount() / 3) + 1}</span>
              <span style="font-size: 0.88rem; font-weight: 700; color: #38bdf8;">${user.username}</span>
              ${user.win_streak && user.win_streak > 1 ? `<span title="Kazanma Serisi" style="font-size:0.85rem; background:linear-gradient(135deg, #f97316, #ef4444); -webkit-background-clip: text; color: transparent; font-weight:900; margin-left:4px;">🔥 ${user.win_streak}</span>` : ''}
            </div>
            
            <div style="position:relative;">
              <button id="nav-notifications-btn" style="background:none; border:none; color:#94a3b8; font-size:1.2rem; cursor:pointer; padding:4px 8px; transition:color 0.2s;" title="Bildirimler">
                🔔
                <span id="nav-notification-badge" style="display:none; position:absolute; top:0; right:0; background:#ef4444; color:white; font-size:0.6rem; font-weight:bold; padding:2px 5px; border-radius:10px; transform:translate(25%, -25%);">0</span>
              </button>
              
              <!-- Dropdown -->
              <div id="nav-notifications-dropdown" style="display:none; position:absolute; top:40px; right:0; width:280px; background:#1e293b; border:1px solid #334155; border-radius:12px; box-shadow:0 10px 25px rgba(0,0,0,0.5); z-index:100; flex-direction:column; overflow:hidden;">
                <div style="padding:10px 14px; background:rgba(0,0,0,0.2); border-bottom:1px solid #334155; font-weight:bold; font-size:0.9rem; display:flex; justify-content:space-between; align-items:center;">
                  <span>Bildirimler</span>
                  <button id="nav-mark-all-read" style="background:none;border:none;color:#6366f1;font-size:0.75rem;cursor:pointer;">Tümünü Okundu İşaretle</button>
                </div>
                <div id="nav-notifications-list" style="max-height:300px; overflow-y:auto; display:flex; flex-direction:column;">
                  <div style="padding:16px; text-align:center; color:#64748b; font-size:0.85rem;">Bildirim yok.</div>
                </div>
              </div>
            </div>

            <button id="nav-logout-btn" style="padding: 6px 12px; background: rgba(239, 68, 68, 0.2); color: #f87171; border: 1px solid rgba(239, 68, 68, 0.4); border-radius: 8px; font-size: 0.82rem; font-weight: 600; transition: all 0.2s ease;">
              Çıkış
            </button>
          </div>
        `
            : `
          <button id="nav-login-btn" style="margin-left: 10px; padding: 8px 18px; background: linear-gradient(135deg, #6366f1, #a855f7); color: #fff; border-radius: 10px; font-weight: 700; font-size: 0.88rem; box-shadow: 0 4px 14px rgba(99, 102, 241, 0.35);">
            🔑 Giriş Yap / Kayıt Ol
          </button>
        `
        }
      </nav>
    `;

    // Append Compact Radio Widget
    const radioContainer = header.querySelector('#nav-radio-container');
    if (radioContainer) {
      radioContainer.appendChild(RadioPlayer.renderCompact());
    }

    // Inject CSS for Nav Buttons
    if (!document.getElementById('nav-styles-v3')) {
      const style = document.createElement('style');
      style.id = 'nav-styles-v3';
      style.innerHTML = `
        .nav-btn {
          display: flex;
          align-items: center;
          gap: 8px;
          padding: 8px 16px;
          border-radius: 10px;
          color: #94a3b8;
          font-weight: 700;
          font-size: 0.92rem;
          border: 1px solid transparent;
          background: rgba(30, 41, 59, 0.5);
          transition: all 0.2s ease;
        }
        .nav-btn__icon {
          font-size: 1.15rem;
        }
        .nav-btn:hover {
          color: #ffffff;
          background: rgba(51, 65, 85, 0.8);
          border-color: #6366f1;
        }
        .nav-btn--active {
          color: #ffffff !important;
          background: linear-gradient(135deg, rgba(99, 102, 241, 0.35), rgba(168, 85, 247, 0.35)) !important;
          border-color: #a855f7 !important;
          box-shadow: 0 4px 16px rgba(168, 85, 247, 0.25);
        }

        @media (max-width: 768px) {
          #hamburger-btn {
            display: block !important;
          }
          #nav-menu {
            display: none !important;
            flex-direction: column;
            width: 100%;
            position: absolute;
            top: 100%;
            left: 0;
            background: rgba(15, 23, 42, 0.95);
            backdrop-filter: blur(16px);
            padding: 20px;
            border-bottom: 2px solid #334155;
            box-shadow: 0 10px 30px rgba(0,0,0,0.5);
          }
          #nav-menu.nav-menu--open {
            display: flex !important;
          }
          .nav-btn {
            width: 100%;
            justify-content: center;
            padding: 12px;
          }
        }
      `;
      document.head.appendChild(style);
    }

    header.querySelector('#nav-logo')?.addEventListener('click', () => onNavigate('lobby'));
    header.querySelectorAll('.nav-btn').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        const tab = (e.currentTarget as HTMLElement).getAttribute('data-tab');
        if (tab) onNavigate(tab);
      });
    });

    const logoutBtn = header.querySelector('#nav-logout-btn');
    if (logoutBtn) {
      logoutBtn.addEventListener('click', () => {
        import('../../services/AuthService').then(({ AuthService }) => {
          AuthService.logout();
        });
      });
    }

    // Check for notifications asynchronously
    const notifBtn = header.querySelector('#nav-notifications-btn');
    const notifBadge = header.querySelector('#nav-notification-badge') as HTMLElement;
    const notifDropdown = header.querySelector('#nav-notifications-dropdown') as HTMLElement;
    const notifList = header.querySelector('#nav-notifications-list') as HTMLElement;
    const markAllReadBtn = header.querySelector('#nav-mark-all-read') as HTMLElement;

    if (notifBtn && notifDropdown && user) {
      notifBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        notifDropdown.style.display = notifDropdown.style.display === 'none' ? 'flex' : 'none';
      });

      document.addEventListener('click', (e) => {
        if (!notifDropdown.contains(e.target as Node) && e.target !== notifBtn) {
          notifDropdown.style.display = 'none';
        }
      });

      markAllReadBtn.addEventListener('click', async (e) => {
        e.stopPropagation();
        import('../../services/ApiClient').then(async ({ ApiClient }) => {
          await ApiClient.markAllNotificationsAsRead(user.id);
          notifBadge.style.display = 'none';
          notifDropdown.querySelectorAll('.unread-notif').forEach(el => {
            (el as HTMLElement).style.background = 'transparent';
            el.classList.remove('unread-notif');
          });
        });
      });

      // Load notifications
      import('../../services/ApiClient').then(async ({ ApiClient }) => {
        const { data: notifs } = await ApiClient.getNotifications(user.id);
        
        if (notifs && notifs.length > 0) {
          const unreadCount = notifs.filter(n => !n.is_read).length;
          if (unreadCount > 0) {
            notifBadge.style.display = 'inline-block';
            notifBadge.innerText = unreadCount.toString();
          }

          notifList.innerHTML = notifs.map(n => `
            <div class="notif-item ${n.is_read ? '' : 'unread-notif'}" data-id="${n.id}" data-type="${n.type}" style="padding:12px 14px; border-bottom:1px solid #334155; cursor:pointer; transition:background 0.2s; background:${n.is_read ? 'transparent' : 'rgba(99, 102, 241, 0.1)'}; display:flex; gap:10px; align-items:start;">
              <span style="font-size:1.2rem;">${n.type === 'friend_request' ? '👥' : n.type === 'duel_invite' ? '⚔️' : '🔔'}</span>
              <div style="flex:1;">
                <div style="font-size:0.85rem; color:#f8fafc; line-height:1.4;">${n.message}</div>
                <div style="font-size:0.7rem; color:#64748b; margin-top:4px;">${new Date(n.created_at).toLocaleString()}</div>
              </div>
              ${!n.is_read ? '<div style="width:8px; height:8px; border-radius:50%; background:#ef4444; margin-top:6px;"></div>' : ''}
            </div>
          `).join('');

          notifList.querySelectorAll('.notif-item').forEach(item => {
            item.addEventListener('click', async (e) => {
              const target = e.currentTarget as HTMLElement;
              const id = parseInt(target.dataset.id!);
              const type = target.dataset.type;

              await ApiClient.markNotificationAsRead(id);
              notifDropdown.style.display = 'none';
              
              if (type === 'friend_request') {
                import('./FriendModal').then(({ FriendModal }) => {
                  FriendModal.show(); // TODO: Add logic to default to requests tab
                });
              }
            });
            
            // Hover effect
            item.addEventListener('mouseenter', () => (item as HTMLElement).style.background = item.classList.contains('unread-notif') ? 'rgba(99, 102, 241, 0.15)' : 'rgba(255,255,255,0.05)');
            item.addEventListener('mouseleave', () => (item as HTMLElement).style.background = item.classList.contains('unread-notif') ? 'rgba(99, 102, 241, 0.1)' : 'transparent');
          });

        }
      });
    }

    const hamburgerBtn = header.querySelector('#hamburger-btn') as HTMLElement;
    const navMenu = header.querySelector('#nav-menu') as HTMLElement;
    if (hamburgerBtn && navMenu) {
      hamburgerBtn.addEventListener('click', () => {
        navMenu.classList.toggle('nav-menu--open');
      });
    }

    header.querySelector('#nav-login-btn')?.addEventListener('click', () => AuthModal.show('login'));
    header.querySelector('#nav-logout-btn')?.addEventListener('click', () => {
      AuthService.logout();
      onNavigate('lobby');
    });

    return header;
  }
}
